import { createSlice } from "@reduxjs/toolkit";
import { getConversations, getMessages, sendMessage } from "../actions/chat";

const states = {
  data: null,
  messages: null,
  conversations: null,
  loading: false,
  error: false,
};

export const chat = createSlice({
  initialState: states,
  name: "chat",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sendMessage.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(sendMessage.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.data = action.payload.data;
    });
    builder.addCase(sendMessage.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });
    builder.addCase(getMessages.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getMessages.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.messages = action.payload.data;
    });
    builder.addCase(getMessages.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });
    builder.addCase(getConversations.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(getConversations.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.conversations = action.payload.data;
    });
    builder.addCase(getConversations.rejected, (state, action) => {
      state.error = true;
      state.loading = false;
    });
  },
});

export default chat.reducer;
